<template>
  <v-app id="degradado" class="myFont">
    
    <!-- Loading Spinner -->
    <loading 
      :active.sync="isLoading" 
      :can-cancel="false" 
      background-color="#FFF"
      color="#A90501"
      loader="spinner"
      :is-full-page="fullPage"
    />

    <!-- Snackbar Alert -->
    <v-snackbar v-model="snackbar" timeout="-1" dark text>
      Tienda cerrada momentáneamente, ya volvemos.
      <template v-slot:action="{ attrs }">
        <v-btn text dark v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar> 

    <!-- Main Content -->
    <v-main class="pt-5">  
      <v-container fluid>
        <!-- Añadido style="min-height: 80vh;" para asegurar que ocupe buen espacio vertical -->
        <v-row no-gutters justify="center" align="center" style="min-height: 80vh;">
          
          <v-col cols="12" sm="12" md="4" class="centrarVerticalmente"> 
            
            <!-- Logo Avatar -->
            <div class="d-flex justify-center mb-6">
              <v-list-item-avatar size="200" :class="avatarHome">
                <img class="pa-0" :src="logo_home" alt="Logo Home">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-row>
                </template>
              </v-list-item-avatar> 
            </div>

            <!-- Controls -->
            <div class="d-flex flex-column align-center w-100">
              
              <v-select
                v-show="perfiles.length > 1"
                v-model="sucursalInput"
                class="mx-4 w-100"
                label="Sucursales"
                prepend-icon="mdi-store"
                :items="perfiles"
                item-text="nombre" 
                item-value="sucursal" 
                outlined
              ></v-select>

              <v-spacer class="mt-3"></v-spacer>       
            </div>
              <v-btn 
                color="primary"
                x-large
                @click="entrar()" 
                class="white--text"
                block
                rounded
              > 
                ENTRAR
              </v-btn>
              
          </v-col>

        </v-row>
      </v-container>
    </v-main>

    <!-- Modo Uso Component -->
    <modoUso />

  </v-app>
</template>

<script>
import modoUso from './components/modoUso.vue'
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
  name: 'Home',
  components: {
    modoUso
  },
  data() {
    return {
      sucursalInput: '',
      isLoading: true,
      fullPage: true,
      snackbar: false
    }
  },
  computed: {
    ...mapState(['perfiles']),
  },
  created() {
    this.reload() 
    this.isLoading = false
  },
  methods: {
    ...mapMutations(['getPerfil']),
    ...mapActions(['miPerfil', 'getProductos']),
    
    async reload() { 
      let payload = {
        'server': this.$server, 
        'empresa': this.$empresa
      }
      
      try {
        await this.miPerfil(payload);   
        if (this.perfiles.length > 0) {
          this.sucursalInput = this.perfiles[0].sucursal
        } else {
          this.snackbar = true
        }
      } catch (error) {
        console.error("Error al cargar perfiles:", error)
        this.snackbar = true
      }
    }, 
    
    async entrar() {
      if (this.perfiles.length == 0) return
      
      let perfiles = this.perfiles.length == 1 
        ? this.perfiles[0] 
        : this.perfiles.find(perfil => perfil.sucursal == this.sucursalInput)

      if (!perfiles) return

      this.getPerfil(perfiles)
      localStorage.setItem('sucursal', perfiles.sucursal)
      
      let urlProductos = this.$server2 + 'data/' + this.$empresa + perfiles.sucursal + ".json";
      
      await this.getProductos(urlProductos);
      this.$router.push({ name: 'productos' })
    }
  }
};
</script>

<style scoped src="./assets/styles/style.css"></style>

<style>
.centrarVerticalmente {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100%; 
}
</style>